import { useEffect } from "react";
import Lenis from "lenis";

// Respect reduced-motion changes without leaving an animation loop running.
export default function useSmoothScroll() {
  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let dispose = () => {};
    const update = () => {
      dispose();
      dispose = () => {};
      if (preference.matches) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      // Lenis 1.x enables touch smoothing by default; keep it on.
      lerp: 0.1,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Expose for in-page anchor scrolling
    window.__lenis = lenis;

    dispose = () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
    };
    update();
    preference.addEventListener("change", update);
    return () => { dispose(); preference.removeEventListener("change", update); };
  }, []);
}
